module.exports = __webpack_public_path__ + "img/paas_wrapbg4.16883a99.png";